import * as Yup from "yup"

export const filterFields = (field, formValues) => {
  const { visibilityRef, value } = field
  const { estadoSGR } = formValues
  const isVisibleField = formValues[visibilityRef]

  if (visibilityRef && !isVisibleField) {
    return false
  }

  if (value === "estadoSGR" && !estadoSGR) {
    return false
  }
  return true
}

export const titularResponseParser = response => {
  const data = { ...response.data }
  const {
    certificadoPYME,
    editarCertificadoPYME,
    responseSGRPlusTo = {},
  } = data || {}

  const { date = "", status = "" } = responseSGRPlusTo || {}

  data.estadoSGR = status || date ? `${status}. ${date}` : null
  const certificadoHasData = certificadoPYME?.length > 0

  data.certificadoPYME = certificadoHasData
    ? certificadoPYME.map(item => ({
        ...item,
        editarCertificadoPYME,
      }))
    : []
  return data
}

export const conditionalRequiredByCertificado = conditionField => {
  return Yup.string()
    .nullable()
    .test(
      "conditional-required",
      "Este campo es obligatorio",
      function (value) {
        const { parent } = this

        if (parent[conditionField]) {
          return !!value
        }
        return true
      },
    )
}

export const conditionalRequiredByCargo = conditionField => {
  return Yup.string()
    .nullable()
    .test(
      "conditional-required",
      "Este campo es obligatorio",
      function (value) {
        const { parent } = this
        const cargo = parent[conditionField]

        if (cargo === "Fiador" || cargo === "Apoderado Firmante") {
          return !!value
        }
        return true
      },
    )
}
